module.exports = __webpack_public_path__ + "static/media/wintergame.11d82a30.png";